<template>
  <div class="container">
    <h1>
      Achievements
      <router-link class="btn btn-success btn-sm pull-right" :to="`/achievements/new`">
        New
      </router-link>
    </h1>
    <hr>

    <div v-for="item in items" :key="item._id">
      <strong :id="`${$embers.slugify(item.name)}`">
        <router-link :to="`/achievements/${item._id}`">{{item.name || 'Achievement'}}</router-link>
      </strong>
      {{item.summary}}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "achievement-index",
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
    this.$embers.pageData("Achievements");
  },
  computed: {
    ...mapState({
      items: state => state.achievements.all
    })
  },
  methods: {
    ...mapActions({
      achievementsAll: "achievements/all"
    }),
    async getData() {
      try {
        this.achievementsAll({ params: `sort=name` });
        this.$embers.pageData("Achievements");
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: 2em;
}
.fa {
  display: inherit;
}
.stock {
  margin-top: -1rem;
  margin-bottom: 0;
  line-height: 0.5em;
  font-size: 0.875rem;
}
.include-stock {
  cursor: pointer;
  line-height: 1.7em;
  vertical-align: top;
}
</style>
